import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import CredibilityBar from "./components/CredibilityBar";
import ServicesSection from "./components/ServicesSection";
import CaseStudies from "./components/CaseStudies";
import InsightsSection from "./components/InsightsSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import BookingPage from "./components/BookingPage";
import CaseStudiesSection from "./components/CaseStudiesSection";
import FAQSection from "./components/FAQSection";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import Disclaimer from "./components/Disclaimer";
import Community from "./components/Community";
import TrainingMaterials from "./components/TrainingMaterials";
import AdminPanel from "./components/AdminPanel";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import CommunityGuidelines from "./components/CommunityGuidelines";
import Pricing from "./components/Pricing";
import ISO42001Tools from "./components/ISO42001Tools";
import ShansoZenLogin from "./components/ShansoZen/Login";
import ShansoZenDashboard from "./components/ShansoZen/Dashboard";
import ShansoATSLogin from "./components/ShansoATS/Login";
import ShansoATSDashboard from "./components/ShansoATS/Dashboard";
import AdminLogin from "./components/Admin/Login";
import AdminComingSoonPanel from "./components/Admin/ComingSoonPanel";

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <CredibilityBar />
      <ServicesSection />
      <CaseStudiesSection />
      <AboutSection />
      <FAQSection />
      <ContactSection />
    </>
  );
};

function App() {
  const location = useLocation();

  // Scroll to top on route change - both on mount and path change
  useEffect(() => {
    // Immediate scroll
    window.scrollTo(0, 0);
    
    // Also ensure scroll after a brief delay (for any async rendering)
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    
    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  // Scroll to top on initial mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dark-container">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/book-consultation" element={<BookingPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/iso42001-tools" element={<ISO42001Tools />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/training" element={<TrainingMaterials />} />
          <Route path="/community/guidelines" element={<CommunityGuidelines />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/shansozen/login" element={<ShansoZenLogin />} />
          <Route path="/shansozen/dashboard" element={<ShansoZenDashboard />} />
          <Route path="/shansoats/login" element={<ShansoATSLogin />} />
          <Route path="/shansoats/dashboard" element={<ShansoATSDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/coming-soon" element={<AdminComingSoonPanel />} />
        </Routes>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;